module.exports = __webpack_public_path__ + "img/symbol_4.ae55fc2e.png";